import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Download, Lock } from "lucide-react";
import { useToast } from "../hooks/use-toast";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const DownloadHotkey = () => {
  const { toast } = useToast();
  const [open, setOpen] = useState(false);
  const [password, setPassword] = useState("");

  useEffect(() => {
    const handler = (e) => {
      // Ctrl + Alt + D
      if (e.ctrlKey && e.altKey && (e.key === "d" || e.key === "D")) {
        e.preventDefault();
        setPassword("");
        setOpen(true);
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, []);

  const handleDownload = (e) => {
    e.preventDefault();
    if (password !== "1243") {
      toast({ title: "Incorrect password", variant: "destructive" });
      return;
    }
    // Trigger secure download from backend
    const url = `${API}/download-site?token=${encodeURIComponent(password)}`;
    const a = document.createElement("a");
    a.href = url;
    a.download = "kyle-gobel-site.zip";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    toast({
      title: "Download started",
      description: "Your production-ready static build is downloading.",
    });
    setOpen(false);
    setPassword("");
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-sm">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl text-[#14213d] flex items-center gap-2">
            <Download size={22} className="text-[#c8a15a]" />
            Download Build
          </DialogTitle>
          <DialogDescription>
            Enter the passcode to download the production-ready static site.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleDownload} className="space-y-4 pt-1">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1.5">Passcode</label>
            <Input
              type="password"
              autoFocus
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter passcode"
              className="h-11"
            />
          </div>
          <Button
            type="submit"
            className="w-full bg-[#c8a15a] hover:bg-[#b58f45] text-[#14213d] font-semibold py-6 gap-2"
          >
            <Lock size={16} /> Download Zip
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default DownloadHotkey;
